<template>
    <div class="home-container">
        <div class="global-background">
            <div class="gradient-overlay"></div>
            <div class="dynamic-texture"></div>
        </div>
        <!-- 智能导航栏 -->
        <Header></Header>
        <!--首屏-->
        <FirstScreen></FirstScreen>
        <!--主旨-->
        <CoreValues></CoreValues>
        <!--产品-->
        <ProductsShowcase></ProductsShowcase>
        <!--优势-->
        <Advantage></Advantage>
        <!--页脚-->
        <Footer></Footer>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { gsap } from 'gsap'
import 'animate.css';
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue"
import FirstScreen from "@/components/FirstScreen.vue"
import CoreValues from "@/components/CoreValues.vue"
import ProductsShowcase from "@/components/ProductsShowcase.vue"
import Advantage from "@/components/Advantage.vue"
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default defineComponent({
    name: 'HomeView',
    components: {
        Header,
        Footer,
        FirstScreen,
        CoreValues,
        ProductsShowcase,
        Advantage,
        // SectionTransition
    },
    data() {
        return {};
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger)

        // 噪点层视差动画
        gsap.to(".noise-layer", {
            scrollTrigger: {
                scrub: 1
            },
            y: () => -ScrollTrigger.maxScroll(window) * 0.3,
            ease: "none"
        })

        // 动态纹理视差
        gsap.to(".dynamic-texture", {
            scrollTrigger: {
                scrub: 0.5
            },
            backgroundPositionY: () => -window.scrollY * 0.2,
            ease: "power2.out"
        })
    },
});
</script>

<style scoped lang="scss">
.home-container {
    background: #0A1A2F; /* 主背景色 */
    position: relative;
    overflow-x: hidden;
}

.gradient-overlay {
    /* 添加硬件加速 */
    transform: translate3d(0, 0, 0);
    will-change: background-position;
}

/* 全局渐变背景样式 */
.global-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: -1;

    .gradient-overlay {
        position: absolute;
        width: 150%;
        height: 150%;

        filter: blur(80px);

        background: linear-gradient(
                45deg,
                #12243D 25%,
                #0A1A2F 50%,
                #12243D 75%
        );
        background-size: 400% 400%;
    }

    .dynamic-texture {
        position: absolute;
        inset: 0;
        background-image: url('data:image/svg+xml,<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="1.2" numOctaves="3"/></filter><rect width="100%" height="100%" filter="url(%23n)" opacity="0.08"/></svg>');
    }
}
</style>
